export const TOPIC_MQTT = {
  CAMERA_EVENT: "spro/camera/object_detected",
  LIDAR_EVENT: "spro/lidar/app/object_detected",
  FENCE_EVENT: "spro/fence/app/object_detected"
};
